import { motion } from 'framer-motion';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function AboutPage() {
  return (
    <div>
      <Header />
      
      <div className="page-header" data-testid="about-header">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p className="section-subtitle">Our Story</p>
            <h1 className="section-title">About Woodhouse & Archer</h1>
          </motion.div>
        </div>
      </div>

      <section className="section section-dark" data-testid="about-content">
        <div className="container">
          <div className="about-content">
            <motion.div 
              className="about-image"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <img 
                src="https://images.unsplash.com/photo-1761350957190-c6546ef07e5b?w=800&q=80" 
                alt="Woodhouse & Archer Office"
              />
            </motion.div>

            <motion.div 
              className="about-text"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h2>A Legacy of Excellence</h2>
              <p>
                Founded with a vision to redefine talent representation, Woodhouse & Archer 
                has grown to become one of the most respected agencies in the entertainment industry.
              </p>
              <p>
                Our approach is simple: we believe in the power of authentic storytelling and 
                the unique voice each performer brings to their craft. We don't just find work 
                for our talent—we build careers, nurture growth, and create lasting partnerships.
              </p>
              <p>
                With a carefully curated roster of exceptional performers, we maintain the 
                personal attention and dedication that larger agencies simply cannot provide. 
                Every talent at Woodhouse & Archer is more than a client; they're part of our family.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="section section-surface" data-testid="values-section">
        <div className="container">
          <motion.div 
            className="section-header"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="section-subtitle">What Drives Us</p>
            <h2 className="section-title">Our Values</h2>
          </motion.div>

          <div className="services-grid">
            {[
              {
                title: "Integrity",
                description: "We operate with complete transparency and honesty in all our dealings, building trust with both talent and industry partners."
              },
              {
                title: "Excellence",
                description: "We hold ourselves and our talent to the highest standards, constantly striving for exceptional work and results."
              },
              {
                title: "Dedication",
                description: "We are committed to the long-term success of our talent, investing time and resources into their career development."
              }
            ].map((value, index) => (
              <motion.div 
                key={index}
                className="card service-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                data-testid={`value-card-${index}`}
              >
                <h3 className="service-title">{value.title}</h3>
                <p className="service-description">{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
